import { defineComponent as Q, useSlots as U, ref as h, toRef as Z, watch as ee, computed as t, useAttrs as te, onMounted as ae, createElementBlock as b, openBlock as x, createElementVNode as s, createCommentVNode as _, normalizeClass as i, mergeProps as re, toHandlers as le, unref as oe, toDisplayString as N, renderSlot as se, normalizeProps as ie, guardReactiveProps as ne, nextTick as ue } from "vue";
import { watchThrottled as de } from "@vueuse/core";
import { useNativeInput as ce } from "../../composables/useNativeInput.js";
import { isEmpty as T } from "../../utils/isEmpty.js";
import { requestAnimationFrame as fe } from "../../utils/requestAnimationFrame.js";
import { tw as e } from "../../utils/tailwind.js";
const ve = { class: "relative" }, me = { class: "body-1 flex w-full items-center" }, pe = ["id", "disabled", "required", "rows", "value"], he = ["for"], be = ["id"], R = 24, P = 4, Ne = /* @__PURE__ */ Q({
  name: "RevInputTextarea",
  inheritAttrs: !1,
  __name: "InputTextarea",
  props: {
    description: { default: "" },
    disabled: { type: Boolean, default: !1 },
    id: {},
    label: {},
    modelValue: {},
    rows: { default: 1 },
    maxRows: { default: void 0 },
    error: { default: void 0 },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "input", "invalid", "valid"],
  setup(l, { emit: H }) {
    const a = l, L = U(), c = H, f = h(a.rows), v = h(null), q = h(null), n = h(null), u = Z(a, "modelValue"), I = (r) => {
      n.value && v.value && v.value.setAttribute("data-cloned-val", r);
    }, d = ce(n, u, {
      onInput: (r) => {
        c("update:modelValue", r.target.value), I(r.target.value), c("input", r);
      }
    });
    ee(
      d.invalid,
      (r, p) => {
        r ? c("invalid", n.value?.validity) : p && c("valid");
      },
      { immediate: !0 }
    );
    const w = t(() => Number(te().maxlength)), g = t(
      () => Number.isInteger(w.value) && w.value > 0
    ), V = t(() => g.value ? w.value - (a.modelValue !== void 0 ? a.modelValue : "").toString().length : Number.POSITIVE_INFINITY), E = t(() => g.value && L.count), S = t(
      () => g.value && V.value < 0
    ), B = t(() => !T(a.description)), y = t(() => !T(a.error)), O = t(
      () => d.touched.value && d.invalid.value
    ), k = t(() => B.value || y.value), z = t(() => E.value || k.value), o = t(
      () => S.value || O.value || y.value
    ), D = t(() => y.value ? a.error : a.description), M = t(() => {
      if (o.value)
        return `${a.id}_error`;
    }), W = t(
      () => typeof a.modelValue == "string" ? !T(a.modelValue) : !(typeof a.modelValue > "u")
    ), m = t(
      () => d.focused.value || W.value
    ), $ = t(() => [
      e`
    not-supports-[line-clamp-1]:after:max-h-[calc(var(--textarea-rows)*1.5em_+_30px)]
    after:line-clamp-[--textarea-rows]
  `,
      f.value === 1 ? e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_24px)]` : e`after:min-h-[calc(var(--textarea-rows)*1.5em_+_28px)]`,
      e`
    w-full
    after:invisible after:overflow-hidden after:whitespace-pre-wrap after:border
    after:px-12 after:text-inherit after:content-[attr(data-cloned-val)_'_']
    after:[grid-area:1/1/2/2]
  `,
      // same as TEXTAREA_PADDING_BOTTOM
      m.value && e`after:pb-4 after:pt-24`,
      !a.disabled && !o.value && e`cursor-text`
    ]), F = t(() => [
      $.value,
      e`peer group grid w-full`
    ]), G = t(() => [
      e`rounded-sm relative min-h-48 border border-solid [grid-area:1/1/2/2]`,
      !a.disabled && e`group-hover:bg-static-default-low-hover group-has-[:hover]:bg-static-default-low-hover`,
      e`has-[:disabled]:bg-static-default-low-disabled has-[:disabled]:border-action-default-low-disabled`,
      !o.value && e`bg-static-default-low border-action-default-low focus-within:border-action-default-low-focus focus-within:outline-default-low`,
      o.value && e`border-action-danger-low focus-within:border-action-danger-low-focus focus-within:outline-danger-low`
    ]), X = t(() => [
      e`rounded-sm input-normalize relative block w-full min-w-0 resize-none overflow-auto`,
      e`bg-transparent px-12 text-inherit outline-none`,
      e`disabled:text-action-default-hi-disabled`,
      // See TEXTAREA_PADDING_BOTTOM
      m.value && e`top-24 min-h-24 pb-4`,
      !m.value && e`min-h-48`,
      !o.value && e`text-action-default-hi`,
      e`motion-safe:transition-colors motion-safe:duration-200`
    ]), Y = t(() => [
      e`absolute inset-x-0 max-w-full -translate-y-1/2 truncate px-12`,
      e`peer peer-has-[:disabled]:text-action-default-hi-disabled`,
      m.value ? e`text-static-default-low caption top-1 transform-none pt-8` : e`text-action-default-hi body-1 top-24`,
      !a.disabled && !o.value && e`cursor-text`,
      e`motion-safe:transition-all motion-safe:duration-200`
    ]), j = t(() => [
      e`body-2 mt-8 flex gap-16 motion-safe:transition-colors motion-safe:duration-200`,
      a.disabled ? e`text-static-default-low-disabled` : e`text-static-default-low`
    ]), J = t(() => [
      e`grow whitespace-nowrap text-right`,
      !a.disabled && S.value && e`text-static-danger-hi`
    ]), K = t(
      () => !a.disabled && o.value && e`text-static-danger-hi`
    );
    function A(r) {
      f.value = Math.min(
        r || a.rows || 1,
        a.maxRows || 1 / 0
      ), fe(() => {
        v.value?.style.setProperty(
          "--textarea-rows",
          f.value.toString()
        );
      });
    }
    async function C() {
      if (!u.value) {
        A(a.rows || 1);
        return;
      }
      await ue();
      const p = ((n.value?.scrollHeight || R + P) - P) / R;
      A(p);
    }
    return de(
      u,
      () => {
        C();
      },
      {
        immediate: !0,
        // post means it happens after the DOM has been updated
        flush: "post",
        throttle: 200
      }
    ), ae(() => {
      I(String(u.value || "")), C();
    }), (r, p) => (x(), b("div", null, [
      s("div", ve, [
        s("div", me, [
          s("div", {
            ref_key: "textareaContainer",
            ref: v,
            class: i(F.value),
            "data-cloned-val": ""
          }, [
            s("div", {
              ref_key: "borderWrapper",
              ref: q,
              class: i(G.value)
            }, [
              s("textarea", re(r.$attrs, {
                id: l.id,
                ref_key: "textarea",
                ref: n,
                class: X.value,
                disabled: l.disabled,
                required: l.required,
                rows: f.value,
                value: u.value
              }, le(oe(d).listeners, !0), { onClick: C }), null, 16, pe)
            ], 2)
          ], 2),
          s("label", {
            class: i(Y.value),
            for: l.id
          }, N(l.label) + N(l.required ? " *" : ""), 11, he)
        ])
      ]),
      z.value ? (x(), b("p", {
        key: 0,
        class: i(j.value)
      }, [
        k.value ? (x(), b("span", {
          key: 0,
          id: M.value,
          class: i(K.value)
        }, N(D.value), 11, be)) : _("", !0),
        E.value ? (x(), b("span", {
          key: 1,
          class: i(J.value)
        }, [
          se(r.$slots, "count", ie(ne({ count: V.value })))
        ], 2)) : _("", !0)
      ], 2)) : _("", !0)
    ]));
  }
});
export {
  Ne as default
};
